module.exports = __webpack_public_path__ + "static/media/logo_login2.6c1e5fa7.png";